<template>
	<div class="row">
		<div class="col-sm-12 px-xl-4 pb-xl-4  overflow-auto">
			<BreadCrumb name="Lead" />
			<LeadCreate
				v-if="
					masterStore.state.activeComponent === 'create' ||
					masterStore.state.activeComponent === 'edit'
				"
			/>
			<LeadShow v-if="masterStore.state.activeComponent === 'view'" />
			<LeadTable v-if="masterStore.state.activeComponent === 'table'" :slug="slug"/>
			<PaymentMultiplier
				v-if="masterStore.state.activeComponent === 'payment'"
			/>
		</div>
	</div>

	<!-- <CreateItinerary /> -->
</template>
<script>
	import { inject, onBeforeUnmount, watch, provide } from "vue";
	import API from "@/config/api";
	import toast from "@/config/toast";

	import BreadCrumb from "@/partials/MasterBreadCrumb.vue";
	import LeadCreate from "@/components/LeadCreate.vue";
	import LeadShow from "@/components/LeadShow.vue";
	import LeadTable from "@/components/LeadTable.vue";
	import PaymentMultiplier from "@/components/PaymentMultiplier.vue";

	export default {
		name: "Lead",
		components: {
			BreadCrumb,
			LeadCreate,
			LeadShow,
			LeadTable,
			PaymentMultiplier,
		},
		props: {
			slug: { type:String, default: "" },
		},

		setup: () => {
			const masterStore = inject("masterStore", masterStore);

			const deleteData = async (id) => {
				try {
					await API.privateRequest.delete(
						`/leads/${masterStore.state.deleteId}`,
					);
					toast.success(
						{ message: "Lead Removed!", position: "topRight" },
						true,
					);
					const newStoreData = masterStore.state.data.filter(
						(item) => item._id !== id,
					);
					masterStore.methods.changeData(newStoreData);
				} catch (err) {
					let message;
					if (err?.response?.status < 500 && err?.response?.status >= 400) {
						message = err.response.data.message;
					} else if (err?.response?.status >= 500) {
						message = "Oops! something went wrong";
					} else {
						message = "App Error";
					}

					toast.error(message, true);
				}
			};
			watch(
				() => masterStore.state.deleteId,
				(newDeleteId, previousDeleteId) => {
					if (!newDeleteId) return;
					deleteData(newDeleteId);
					masterStore.methods.setId("delete", previousDeleteId);
				},
			);
			onBeforeUnmount(masterStore.methods.destroy());

			return {
				deleteData,
				masterStore,
			};
		},
	};
</script>
